import React, {
    useState,
    useEffect,
    useImperativeHandle,
    forwardRef,
  } from "react";
  import PositiveIntegerInput from "./PositiveIntegerInput";
  
  const Duration = forwardRef(({ attributes, initialValues = {}, onSubmit, checkUnAppliedChanges }, ref) => {
    const [value, setValue] = useState(initialValues.duration_number_of_bars);
    const [isValid, setIsValid] = useState(false);
  
    // Expose the submit function to parent via ref
    useImperativeHandle(ref, () => ({
      submit: () => {
        if (isValid && onSubmit) {
          onSubmit({ ...initialValues, duration_number_of_bars: value });
        }
      },
      discardChanges: () => {
        setValue(initialValues.duration_number_of_bars);
      },
      getValue: () => { return value; },
    }), [value, initialValues, onSubmit, isValid]);
  
    useEffect(() => {
      const isValidValue = Number.isInteger(value) && value >= 0;
      setIsValid(isValidValue);
      checkUnAppliedChanges();
    }, [value]);
  
    const handleChange = (newValue) => {
      setValue(newValue);
    };
  
    // Locate the field definition from attributes
    const field = (() => {
      for (const group of Object.values(attributes || {})) {
        const match = group.find((f) => f.name === "duration_number_of_bars");
        if (match) return match;
      }
      return null;
    })();
  
    if (!field) return null;
  
    return (
      <div style={{ minWidth: '300px', width: "30%" }}>
        <PositiveIntegerInput
          label={field.questionText ?? field.name}
          mandatory={field.mandatory}
          maxValue={field.maxValue}
          instruction={field.instruction}
          value={value}
          onChange={handleChange}
        />
      </div>
    );
  });
  
  export default Duration;
  